import React, { Component } from 'react';
import Cards from 'react-credit-cards';
// import CreditCardInput from 'react-credit-card-input';
import CreditCardInput from '../card/card-input-lib';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import 'react-credit-cards/es/styles-compiled.css';
import './card.css';
import validator from 'validator';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
  }
};
const alphapet = (value) => {
  var patt = new RegExp("^((?:[A-Za-z]+ ?){1,3})$");
  if(!patt.test(value)){
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert">Please enter valid cardholder name.</div>;
  }
};
class card extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardNumber: '',
            cardHolderName: '',
            expiry: '',
            cvc: '',
            focus: '',
            card_error: false,
            card_complate: false
        };
    }
    handleCardNumberChange = (e) => {
        this.setState({cardNumber: e.target.value, card_error: false},() => {
            this.props.cardNumber(this.state.cardNumber)
            this.check_card_complate()
        });
    }
    handleCardNumberChange2 = (e) => {
        let paste = (e.clipboardData || window.clipboardData).getData('text');
        this.setState({cardNumber: paste, card_error: false},() => {
            this.props.cardNumber(this.state.cardNumber)
            this.check_card_complate()
        });
    }
    handleCardExpiryChange = (e) => {
        this.setState({expiry: e.target.value, card_error: false},() => {
            this.props.cardExpiry(this.state.expiry)
            this.check_card_complate()
        });
    }
    handleCardCVCChange = (e) => {
        this.setState({cvc: e.target.value, card_error: false},() => {
            this.props.cardCvv(this.state.cvc)
            this.check_card_complate()
            if(this.state.cvc.length === 3){
                document.getElementById("cardHolderInput").focus();
            }
        });
    }
    handelCardHolderName = (e) => {
        this.setState({cardHolderName: e.target.value.toUpperCase()},() => {
            this.props.cardHolder(this.state.cardHolderName)
            this.check_card_complate()
        });
    }
    handelSaveCardChange = (e) => {
        this.setState({saveCard: e.target.checked},() => {
            this.props.saveCard(this.state.saveCard)
            this.check_card_complate()
        });
    }
    handleInputFocus = (e) => {
        this.setState({ focus: e.target.name });
    }
    check_card_complate = () => {
        var patt = new RegExp("^((?:[A-Za-z]+ ?){1,3})$");
        if(
            this.state.cardNumber.replace(/ /g,'').length === 16 &&
            this.state.expiry.replace(/ /g,'').length >= 5 &&
            this.state.cvc.length >= 3 &&
            this.state.cardHolderName.length >= 1 &&
            patt.test(this.state.cardHolderName)&&
            !this.state.card_error
        ){
            
            this.props.cardValid(true);
            // this.setState({card_complate: true})
        }else{
            this.props.cardValid(false);
            // this.setState({card_complate: false})
        }
    }
    handleSubmit = (e) => {
        e.preventDefault();
        // this.handleInputFocus(e);
        // let card_data  = {
        //     "number": this.state.cardNumber,
        //     "cardNumber": this.state.cardNumber.replace(/ /g,''),
        //     "name": this.state.cardHolderName,
        //     "expiry": this.state.expiry.replace(/ /g,''),
        //     "expiry_mm": this.state.expiry.replace(/ /g,'').slice(0, 2),
        //     "expiry_yy": this.state.expiry.replace(/ /g,'').slice(-2),
        //     "cvc": this.state.cvc,
        // }
        // this.props.card_submit(card_data)
    }
    render() {
        return (
            <div className={this.props.waiting ? "iframeCardNew ele_blur" : "iframeCardNew"}>
                <div>
                    <Cards
                        cvc={this.state.cvc}
                        expiry={this.state.expiry.replace(/ /g,'')}
                        focused={this.state.focus}
                        name={this.state.cardHolderName}
                        number={this.state.cardNumber}
                    />
                    <CreditCardInput
                        onError={({ inputName, err }) => { 
                            setTimeout(() => {
                                this.setState({card_error: true}, () => {
                                    this.check_card_complate()
                                })
                            }, 10);
                        }}
                        cardNumberInputProps={{ 
                            autoFocus: true,
                            name: "number",
                            value: this.state.cardNumber, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardNumberChange, 
                            onPaste: this.handleCardNumberChange2, 
                            onFocus: this.handleInputFocus
                        }}
                        cardExpiryInputProps={{ 
                            name: "expiry",
                            value: this.state.expiry, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardExpiryChange, 
                            onFocus: this.handleInputFocus 
                        }}
                        cardCVCInputProps={{ 
                            name: "cvc",
                            value: this.state.cvc, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardCVCChange, 
                            onFocus: this.handleInputFocus 
                        }}
                        fieldClassName="input"
                    />
                    <Form onSubmit={this.handleSubmit}>
                        <div className="newInput">
                        <Input 
                            id="cardHolderInput"
                            type="text" 
                            name="name" 
                            placeholder="Card Holder Name"
                            autoComplete="off"
                            value={this.state.cardHolderName}
                            disabled={this.props.waiting}
                            onChange={this.handelCardHolderName}
                            onFocus={this.handleInputFocus}
                            validations={[required, alphapet]} 
                        />
                        </div>
                        {this.props.can_save_card && this.props.can_save_card === true &&
                            <div class="disclaimer">
                                <p>your card data will be saved for future installments</p>
                            </div>
                        }
                        {/* {this.props.can_save_card &&
                            <div class="form-group accept-terms">
                                <input 
                                    type="checkbox" 
                                    id="save-card"
                                    disabled={this.props.waiting}
                                    onChange={this.handelSaveCardChange}
                                />
                                <label for="save-card">Save card for future use</label>
                            </div>
                        } */}
                        {/* <div className='text-center newCardFooter'>
                            {this.props.waiting ? 
                                <button className="newCardButton" disabled><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div> </button> 
                            : 
                                this.state.card_error || !this.state.card_complate ?
                                    <button className="newCardButton" disabled>PAY NOW</button>
                                    
                                :
                                    <Button className="newCardButton">PAY NOW</Button>
                            }
                            <div className="secured_by">
                                <i className="fa fa-lock"></i>
                                Secured by Paymob
                            </div>
                        </div> */}
                    </Form>
                </div>
            </div>
        );
    }
}

export default card;